import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/ai/Assistant/list", {
        params: {
            ...params
        }
    } )
}

function GET_SEACH(params) {
    return axios.get("/ai/Assistant/selects", {
        params: {
            ...params
        }
    } )
}

function CHANG_STATUS (params) {
    return  axios.post("/ai/Assistant/editStatus",{...params} )
}
export default {
    GET_LIST,
    GET_SEACH,CHANG_STATUS
}